import { useState, useEffect } from 'react';
import BackButton from '../components/BackButton';
import { useApp } from '../App';
import api from '../api';
import { useI18n } from '../i18n/index.jsx';

export default function TopUp() {
  const { user } = useApp();
  const { t } = useI18n();
  const [depositInfo, setDepositInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [amount, setAmount] = useState('');
  const [txHash, setTxHash] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    loadDepositInfo();
  }, []);

  async function loadDepositInfo() {
    try {
      const { data } = await api.get('/crypto/deposit-info');
      setDepositInfo(data);
    } catch (e) {
      setMessage({ type: 'error', text: e.userMessage || 'Ошибка загрузки' });
    } finally {
      setLoading(false);
    }
  }

  async function submitDeposit() {
    if (!amount || parseFloat(amount) < 10) {
      setMessage({ type: 'error', text: t('top_up.min_amount') });
      return;
    }
    setSubmitting(true);
    try {
      await api.post('/crypto/deposit/create', {
        amount_usdt: parseFloat(amount),
        tx_hash: txHash || null,
      });
      setMessage({ type: 'success', text: '✅ Заявка на пополнение создана! Ожидайте подтверждения.' });
      setAmount('');
      setTxHash('');
    } catch (e) {
      setMessage({ type: 'error', text: e.userMessage || 'Ошибка' });
    } finally {
      setSubmitting(false);
    }
  }

  function copyAddress() {
    navigator.clipboard.writeText(depositInfo?.wallet_address || '');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  if (loading) return <div className="page">
      <BackButton /><div className="loader">{t('common.loading')}</div></div>;

  return (
    <div className="page">
      <BackButton />
      <h1>💰 Пополнение баланса</h1>

      {message && (
        <div style={{
          padding: 12,
          borderRadius: 8,
          marginBottom: 16,
          background: message.type === 'error' ? 'rgba(220,38,38,0.2)' : 'rgba(16,185,129,0.2)',
        }}>
          {message.text}
        </div>
      )}

      {/* USDT Deposit */}
      <div style={{
        background: 'linear-gradient(135deg, #26a17b 0%, #1a7a5c 100%)',
        borderRadius: 12,
        padding: 20,
        marginBottom: 24,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
          <span style={{ fontSize: 24 }}>₮</span>
          <span style={{ fontSize: 20, fontWeight: 'bold' }}>USDT (TRC20)</span>
        </div>

        <div style={{
          background: 'rgba(255,255,255,0.1)',
          borderRadius: 8,
          padding: 12,
          marginBottom: 12,
        }}>
          <div style={{ fontSize: 12, opacity: 0.8, marginBottom: 4 }}>Адрес кошелька:</div>
          <div style={{
            fontFamily: 'monospace',
            fontSize: 12,
            wordBreak: 'break-all',
            marginBottom: 8,
          }}>
            {depositInfo?.wallet_address}
          </div>
          <button
            className="btn btn-small"
            style={{ background: 'rgba(255,255,255,0.2)' }}
            onClick={copyAddress}
          >
            {copied ? '✅ Скопировано!' : '📋 Копировать адрес'}
          </button>
        </div>

        <div style={{ fontSize: 13, opacity: 0.9 }}>
          ⚠️ Отправляйте ТОЛЬКО USDT по сети <b>TRC20</b>!
        </div>
      </div>

      {/* Submit Form */}
      <div style={{
        background: 'rgba(255,255,255,0.05)',
        borderRadius: 12,
        padding: 20,
        marginBottom: 24,
      }}>
        <h3 style={{ marginTop: 0 }}>📝 Я оплатил</h3>

        <div style={{ marginBottom: 12 }}>
          <label style={{ display: 'block', marginBottom: 4, opacity: 0.7 }}>Сумма (USDT):</label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Например: 100"
            min="10"
            style={{
              width: '100%',
              padding: 12,
              borderRadius: 8,
              border: '1px solid rgba(255,255,255,0.2)',
              background: 'rgba(255,255,255,0.05)',
              color: '#fff',
              fontSize: 16,
            }}
          />
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 4, opacity: 0.7 }}>Hash транзакции (необязательно):</label>
          <input
            type="text"
            value={txHash}
            onChange={(e) => setTxHash(e.target.value)}
            placeholder="Например: abc123..."
            style={{
              width: '100%',
              padding: 12,
              borderRadius: 8,
              border: '1px solid rgba(255,255,255,0.2)',
              background: 'rgba(255,255,255,0.05)',
              color: '#fff',
              fontSize: 14,
            }}
          />
        </div>

        <button
          className="btn btn-primary"
          style={{ width: '100%' }}
          onClick={submitDeposit}
          disabled={submitting || !amount}
        >
          {submitting ? '⏳ Отправка...' : '✅ Подтвердить оплату'}
        </button>
      </div>

      {/* Instructions */}
      <div style={{ fontSize: 13, opacity: 0.7 }}>
        <h4>Инструкция:</h4>
        <ol style={{ paddingLeft: 20 }}>
          {depositInfo?.instructions?.map((inst, i) => (
            <li key={i} style={{ marginBottom: 4 }}>{inst}</li>
          ))}
        </ol>
        <p>⏱ Время обработки: {depositInfo?.processing_time}</p>
      </div>
    </div>
  );
}
